import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["amenitiesModal"]

  connect() {
    // Bind the escape key handler
    this.handleEscapeKey = this.handleEscapeKey.bind(this)
    document.addEventListener("keydown", this.handleEscapeKey)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleEscapeKey)
  }

  showAmenitiesModal() {
    this.amenitiesModalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  hideAmenitiesModal() {
    this.amenitiesModalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  // Close modal when clicking outside
  closeBackground(event) {
    if (event.target === this.amenitiesModalTarget) {
      this.hideAmenitiesModal()
    }
  }

  // Close modal with escape key
  handleEscapeKey(event) {
    if (event.key === "Escape") {
      this.hideAmenitiesModal()
    }
  }
}
